import { defineMessages } from 'react-intl';

export const search = defineMessages({
  placeholder: {
    id: 'myEvents.search.placeholder',
    description: 'Placeholder for search bar',
    defaultMessage: 'Search all events by name'
  }
});
